<div class="surface-section px-4 py-8 md:px-6 lg:px-8">
    <div style="background: radial-gradient(50% 109137.91% at 50% 50%, rgba(233, 30, 99, 0.1) 0%, rgba(254, 244, 247, 0) 100%);" class="text-center">
        <span class="bg-white text-pink-700 font-bold text-2xl inline-block px-3">Error!</span>
    </div>
    <div class="mt-6 mb-5 font-bold text-6xl text-900 text-center">Error!</div>
    <p class="text-700 text-3xl mt-0 mb-6 text-center">Sorry, we couldn't load payment information.</p>
    <p class="text-700 text-3xl mt-0 mb-6 text-center">Please try again later.</p>
</div>